import { SystemStyleObject } from "@chakra-ui/react";

export const chakraUiTabsListCss: SystemStyleObject = {
  display: "flex",
  alignItems: "center",
  gap: "24px",

  "@media screen and (max-width: 725px)": {
    flexDirection: "column",
    gap: "12px",
  },
};

export const chakraUiTabsTriggerCss: SystemStyleObject = {
  fontSize: "14px",
  fontWeight: "600",
  lineHeight: "19.12px",
  height: "28px",
  padding: "0 0 9px",

  "@media screen and (max-width: 725px)": {
    height: "fit-content",
  },
};
